/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Labs_Predictor_PaceInputs */

const en_ui_labs_predictor_pace = /** @type {(inputs: Ui_Labs_Predictor_PaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pace`)
};

const de_ui_labs_predictor_pace = /** @type {(inputs: Ui_Labs_Predictor_PaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pace`)
};

/**
* | output |
* | --- |
* | "Pace" |
*
* @param {Ui_Labs_Predictor_PaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_labs_predictor_pace = /** @type {((inputs?: Ui_Labs_Predictor_PaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Labs_Predictor_PaceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_labs_predictor_pace(inputs)
	return de_ui_labs_predictor_pace(inputs)
});